import React, { useEffect, useState } from 'react';
import styled, { ThemeProvider, css } from 'styled-components';
import { DefaultTheme } from '../../Themes';
import { SwitchStatus } from './types';
const StyledContainer = styled.div `
  display: inline-flex;
  align-items: center;
  padding: 0.166666667rem;
  border-radius: 12.5rem;
  background-color: #aaa;
  cursor: pointer;

  ${({ status }) => status === SwitchStatus.ON && css `
    justify-content: flex-end;
    background-color: #70b603;
  `};
`;
const StyledIndicator = styled.div `
  display: inline-block;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.ColorNames.WHITE.hex};
`;
const getSwitchedStatus = (currentStatus) => (currentStatus === SwitchStatus.OFF ? SwitchStatus.ON : SwitchStatus.OFF);
const handleClick = (currentStatus, setCurrentStatus, onClick) => {
    const switchedStatus = getSwitchedStatus(currentStatus);
    setCurrentStatus(switchedStatus);
    onClick(switchedStatus);
};
const Switch = ({ height = 32, status = SwitchStatus.OFF, onClick = () => { }, theme = DefaultTheme, }) => {
    const [currentStatus, setCurrentStatus] = useState(status);
    useEffect(() => {
        setCurrentStatus(status);
    }, [status]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, { status: currentStatus, style: { height, width: height * 2 }, onClick: () => handleClick(currentStatus, setCurrentStatus, onClick) },
            React.createElement(StyledIndicator, { style: { height, width: height } }))));
};
export default Switch;
